/**
 * `companyId` real, o `null` si el usuario no tiene empresa.
 *
 * `ArcaContext.companyId` se hidrata de `localStorage`, y ahí un usuario sin
 * empresa NO queda como `null`: queda como la CADENA `"null"`. Pasa porque
 * `localStorage.setItem('companyId', null)` coacciona el valor a texto, y ni
 * `LoginFormV2` ni `UserInvitationV2` lo normalizan al escribirlo.
 *
 * La cadena `"null"` es **truthy**, así que cualquier `if (companyId)` la da por
 * buena y la manda al backend como si fuese una empresa de verdad. Eso ya ha
 * mordido dos veces:
 *
 *  - escondió el botón de aportación puntual a los individuales puros (DEV, 10-ago);
 *  - y hace que `POST /feature-flags/check/:name` responda 401, porque su guard
 *    `hasCompanyAccess(userId, "null")` es falso — dejando la feature apagada en
 *    silencio justo para el público al que se le abre.
 *
 * Devuelve `null` y no `''` para que el llamador decida: los dos son falsy, pero
 * `null` dice "no tiene empresa" y `''` se lee como "no lo sé".
 */
export const resolveRealCompanyId = (companyId: string | null | undefined): string | null =>
	!companyId || companyId === 'null' || companyId === 'undefined' ? null : companyId;

export default resolveRealCompanyId;
